import React from 'react';
import SectionHead from 'ui-components/SectionHead';
import { showTable, sortClients } from 'utils/utils';
import ClientsTable from '../clients-table/ClientsTable';

import './direct-clients.scss';

const DirectClients = ({clients}) => {
    return (
        <div className="direct-clients">
            <SectionHead head={"Direct"}/> 
            {   showTable(clients.activeICBC) &&
                    <ClientsTable 
                        clientsData={sortClients(clients.activeICBC)} 
                        tableHead={"Active Clients -  ICBC"} 
                        isDirect={true} 
                        isICBC={true}
                    />
            }
            {
                showTable(clients.deactivatedICBC) &&
                    <ClientsTable 
                        clientsData={sortClients(clients.deactivatedICBC)} 
                        tableHead={"Deactivated clients -  ICBC"} 
                        isDirect={true} 
                        isICBC={true} 
                        isDeactivated={true}
                    />
            }
            {
                showTable(clients.activeOther) &&
                    <ClientsTable 
                        clientsData={sortClients(clients.activeOther)} 
                        tableHead={"Active Clients - Other Direct (CFSEU, CVAP, FNHA) "} 
                        isDirect={true}
                    />
            }
            
            {
                showTable(clients.deactivatedOther) && 
                    <ClientsTable 
                        clientsData={sortClients(clients.deactivatedOther)} 
                        tableHead={"Deactivated Clients -  Other Direct (CFSEU, CVAP, FNHA) "} 
                        isDirect={true} 
                        isDeactivated={true}
                    />
            }
        </div>
    );
};

export default DirectClients;